/**
 * "Combina tu look y ahorra más" (carrito lateral).
 * Botón "Lo quiero" (añade), botón "Quitar" (deshace lo añadido desde aquí), talla y flechas.
 * Se carga una sola vez en toda la web y usa delegación de eventos,
 * así sigue funcionando aunque el carrito se redibuje.
 */
import { CartLinesUpdateEvent } from '@shopify/events';
import { sectionRenderer } from '@theme/section-renderer';

if (!window.__cmUpsell) {
  window.__cmUpsell = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  const getSectionIds = () => [
    ...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId)),
  ];

  const rerender = (sectionIds) => {
    try {
      sectionIds.forEach((sid) => sectionRenderer.renderSection(sid, { cache: false, mode: 'hydration' }));
    } catch (err) {
      window.location.reload();
    }
  };

  const syncCard = (card) => {
    const sel = card.querySelector('[data-cm-variant]');
    const btn = card.querySelector('[data-cm-add]');
    if (!sel || !btn) return;
    const o = sel.selectedOptions[0];
    if (!o) return;
    btn.dataset.variantId = o.value;
    const price = card.querySelector('[data-cm-price]');
    if (price && o.dataset.price) price.textContent = o.dataset.price;
    const c = card.querySelector('[data-cm-compare]');
    if (c) {
      c.textContent = o.dataset.compare || '';
      c.hidden = !o.dataset.compare;
    }
  };

  const onVariantChange = (e) => {
    const sel = e.target.closest && e.target.closest('[data-cm-variant]');
    if (!sel) return;
    const card = sel.closest('[data-cm-card]');
    if (card) syncCard(card);
  };
  document.addEventListener('change', onVariantChange);
  document.addEventListener('input', onVariantChange);

  async function removeLine(btn) {
    const key = btn.dataset.key;
    if (!key) return;
    const sectionIds = getSectionIds();
    const label = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: json,
        body: JSON.stringify({ id: key, quantity: 0, sections: sectionIds.join(','), sections_url: window.location.pathname }),
      });
      const cart = await res.json();
      if (!res.ok || cart.status) throw new Error(cart.description || cart.message || 'No se pudo quitar');
      let done = false;
      try {
        const d = CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(
          new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [{ id: key, quantity: 0 }], promise: d.promise })
        );
        d.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { sections: cart.sections, items: cart.items, itemCount: cart.item_count, source: 'cm-cart-upsell-remove', didError: false },
        });
        done = true;
      } catch (err) {
        console.warn('[cm-upsell]', err);
      }
      if (!done) rerender(sectionIds);
    } catch (err) {
      console.warn('[cm-upsell]', err);
      btn.textContent = 'Error, reintenta';
      setTimeout(() => {
        if (btn.isConnected) {
          btn.innerHTML = label;
          btn.removeAttribute('aria-busy');
        }
      }, 2000);
    }
  }

  document.addEventListener('click', async (e) => {
    const arrow = e.target.closest && e.target.closest('[data-cm-dir]');
    if (arrow) {
      e.preventDefault();
      const wrap = arrow.closest('[data-cm-upsell]');
      const list = wrap && wrap.querySelector('[data-cm-list]');
      if (list) list.scrollBy({ left: Number(arrow.dataset.cmDir) * list.clientWidth, behavior: 'smooth' });
      return;
    }

    const rm = e.target.closest && e.target.closest('[data-cm-remove]');
    if (rm) {
      e.preventDefault();
      e.stopPropagation();
      if (rm.getAttribute('aria-busy') === 'true') return;
      removeLine(rm);
      return;
    }

    const btn = e.target.closest && e.target.closest('[data-cm-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;

    const card = btn.closest('[data-cm-card]');
    const sel = card && card.querySelector('[data-cm-variant]');
    const id = Number(sel ? sel.value : btn.dataset.variantId);
    if (!id) return;

    const sectionIds = getSectionIds();
    const label = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: json,
        body: JSON.stringify({
          items: [{ id, quantity: 1, properties: { _cm_upsell: '1' } }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo añadir');

      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      let done = false;
      try {
        const deferred = CartLinesUpdateEvent.createPromise();
        const line = data.items && data.items[0];
        document.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'cart',
            lines: [{ id: line ? line.key : String(id), quantity: 1 }],
            promise: deferred.promise,
          })
        );
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { sections: data.sections, items: data.items, itemCount: cart.item_count, source: 'cm-cart-upsell', didError: false },
        });
        done = true;
      } catch (err) {
        console.warn('[cm-upsell]', err);
      }
      if (!done) rerender(sectionIds);
      if (btn.isConnected) {
        btn.innerHTML = label;
        btn.removeAttribute('aria-busy');
      }
    } catch (err) {
      console.warn('[cm-upsell]', err);
      btn.textContent = 'No disponible';
      setTimeout(() => {
        btn.innerHTML = label;
        btn.removeAttribute('aria-busy');
      }, 2000);
    }
  });
}
